import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy, Router } from '@angular/router';
import { TagInputModule } from 'ngx-chips';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { IonicStorageModule } from '@ionic/storage';
import { AuthInterceptor } from './models/AuthInterceptor';
import { FileUploadModule } from 'ng2-file-upload';
import { SharedService } from './services/shared-service/shared.service';
import { DeleteAlertComponent } from './pages/menu/alerts/delete-alert/delete-alert.component';
import { AddNewMetattachAlertComponent } from './pages/menu/alerts/add-new-metattach-alert/add-new-metattach-alert.component';
import { HeaderComponent } from './components/layout/header/header.component';
import { SideNaveComponent } from './components/layout/side-nav/side-nav.component';
import { GlobalSnipperComponent } from './common/global-snipper/global-snipper.component';
import * as Sentry from "@sentry/angular";

@NgModule({
	declarations: [AppComponent,DeleteAlertComponent,AddNewMetattachAlertComponent, HeaderComponent, SideNaveComponent],
	entryComponents: [DeleteAlertComponent,AddNewMetattachAlertComponent],
	imports: [
		BrowserModule,
		TagInputModule,
		IonicModule.forRoot(),
		AppRoutingModule,
		HttpClientModule,
		BrowserAnimationsModule,
		ReactiveFormsModule,
		IonicStorageModule.forRoot(),
		FormsModule,
		FileUploadModule,
		GlobalSnipperComponent
	],
	providers: [
		StatusBar,
		SplashScreen,
		SharedService,
		{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
		{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
		{
			provide: ErrorHandler,
			useValue: Sentry.createErrorHandler(),
		},
		{
			provide: Sentry.TraceService,
			deps: [Router],
		},
		{
			provide: APP_INITIALIZER,
			useFactory: () => () => { },
			deps: [Sentry.TraceService],
			multi: true,
		}
	],
	bootstrap: [AppComponent]
})
export class AppModule { }
